import { useCart } from "../context/CartContext";
import { fmt } from "../lib/api";
import { Minus, Plus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const CartSidebar = () => {
  const { items, open, setOpen, removeItem, updateQty, subtotal, lineKey } = useCart();
  const nav = useNavigate();

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
            className="fixed inset-0 z-[60] bg-black/30"
          />
          <motion.aside
            data-testid="cart-sidebar"
            initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }}
            transition={{ type: "tween", duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="fixed top-0 right-0 z-[70] h-full w-full sm:w-[440px] bg-white flex flex-col"
          >
            <div className="flex items-center justify-between px-8 py-6 border-b border-border">
              <h3 className="product-title text-[13px]">Bag ({items.reduce((s, i) => s + i.quantity, 0)})</h3>
              <button data-testid="cart-close" onClick={() => setOpen(false)} className="util-link text-sm link-hover">Close</button>
            </div>

            {items.length === 0 ? (
              <div className="flex-1 flex flex-col items-center justify-center gap-6 text-graphite">
                <p className="text-sm">Your bag is empty.</p>
                <button className="bg-black text-white px-8 py-3 text-[13px] product-title link-hover"
                  onClick={() => { setOpen(false); nav("/shop"); }} data-testid="cart-empty-shop">
                  Explore
                </button>
              </div>
            ) : (
              <>
                <div className="flex-1 overflow-y-auto px-8 py-5 space-y-6">
                  {items.map((it) => {
                    const k = lineKey(it);
                    return (
                      <div key={k} data-testid="cart-item" className="flex gap-4">
                        <img src={it.image} alt={it.name} className="w-20 h-24 object-cover bg-card" />
                        <div className="flex-1">
                          <div className="flex justify-between gap-2">
                            <p className="product-title text-[12px]">{it.name}</p>
                            <button onClick={() => removeItem(k)} data-testid="cart-remove"
                              className="util-link link-hover">Remove</button>
                          </div>
                          <p className="text-xs caption mt-1">{[it.size, it.color].filter(Boolean).join(" · ")}</p>
                          <div className="flex justify-between items-center mt-3">
                            <div className="flex items-center border border-border">
                              <button className="px-2.5 py-1.5" onClick={() => updateQty(k, it.quantity - 1)} data-testid="cart-dec"><Minus className="w-3 h-3" /></button>
                              <span className="text-sm w-6 text-center">{it.quantity}</span>
                              <button className="px-2.5 py-1.5" onClick={() => updateQty(k, it.quantity + 1)} data-testid="cart-inc"><Plus className="w-3 h-3" /></button>
                            </div>
                            <span className="text-sm">{fmt(it.price * it.quantity)}</span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="border-t border-border px-8 py-6 space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="util-link text-[11px]">Subtotal</span>
                    <span data-testid="cart-subtotal" className="text-lg">{fmt(subtotal)}</span>
                  </div>
                  <button data-testid="cart-checkout"
                    onClick={() => { setOpen(false); nav("/checkout"); }}
                    className="w-full bg-black text-white py-4 product-title text-[13px] link-hover">
                    Checkout
                  </button>
                  <p className="text-center text-xs caption">Free shipping over $150 · 30-day returns</p>
                </div>
              </>
            )}
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
};
